import React from 'react';
import { motion } from 'framer-motion';
import { Gift, FileText, ClipboardList, Lightbulb } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    icon: FileText,
    number: 1,
    title: 'Guía de Psicoeducación para Familias de Gerontes',
    description: 'Material descargable listo para entregar a familiares.',
    details: [],
    footer: 'Para que el psicólogo tenga un recurso profesional listo para orientar a la familia sin improvisar cada explicación ni perder el encuadre del proceso terapéutico.'
  }, {
    icon: ClipboardList,
    number: 2,
    title: 'Plantilla de Evaluación Inicial del Geronte',
    description: 'Planilla editable para registrar información clínica relevante desde la primera consulta.',
    details: [],
    footer: 'Para que no tengas que improvisar la primera entrevista y puedas ordenar la información importante desde el inicio.'
  }, {
    icon: Lightbulb,
    number: 3,
    title: 'Guía de Actividades Terapéuticas para Gerontes',
    description: 'Banco de actividades simples para trabajar en sesión o entre sesiones.',
    details: [],
    footer: 'Para evitar que las sesiones se vuelvan solamente conversacionales y sumar recursos concretos sin perder profundidad clínica.'
  }];
  return <section className="w-full py-16 md:py-24 bg-white" data-id="element-12">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-4" data-id="element-14">
          <div className="inline-block bg-green-500 text-white px-6 py-2 rounded-full font-bold text-lg mb-6 shadow-lg" data-id="element-15">
            <Gift className="inline-block w-5 h-5 mr-2 -mt-1" data-id="element-16" />
            ¡GRATIS POR EL DÍA DE HOY!
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#14505c] mb-4" data-id="element-17">
            OFERTA ESPECIAL: BONUS PROFESIONALES
          </h2>
          <p className="text-xl font-semibold text-gray-700" data-id="element-18">
            INCLUIDOS CON TU COMPRA
          </p>
        </motion.div>

        <div className="space-y-8 mt-12" data-id="element-19">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="bg-[#faf9f7] p-8 rounded-lg shadow-md border-2 border-green-500 relative" data-id="element-20">
                <div className="absolute -top-3 left-6 bg-green-500 text-white px-4 py-1 rounded-full text-sm font-bold" data-id="element-21">
                  ¡Incluido hoy!
                </div>
                <div className="flex items-start gap-6" data-id="element-22">
                  <div className="flex-shrink-0" data-id="element-23">
                    <div className="w-16 h-16 bg-[#d97706] rounded-full flex items-center justify-center" data-id="element-24">
                      <Icon className="w-8 h-8 text-white" data-id="element-25" />
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-26">
                    <h3 className="text-2xl font-bold text-[#14505c] mb-2" data-id="element-27">
                      BONUS #{bonus.number} — {bonus.title}
                    </h3>
                    <p className="text-gray-700 font-medium mb-4" data-id="element-28">
                      {bonus.description}
                    </p>
                    {bonus.details.length > 0 && <div className="mb-4" data-id="element-29">
                        <p className="text-gray-600 mb-2" data-id="element-30">
                          Explica de forma simple:
                        </p>
                        <ul className="space-y-1 text-gray-600" data-id="element-31">
                          {bonus.details.map((detail, idx) => <li key={idx} className="ml-4" data-id="element-32">
                              • {detail}
                            </li>)}
                        </ul>
                      </div>}
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}